import PrivateImage from 'Modules/PrivateImage/PrivateImage';
import { bool, func, number, shape } from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { openGallery } from 'Redux/modules/webChat/allMedia/actions';

const MAX_WIDTH = 180;
const MAX_HEIGHT = 320;

const WIDTH_THUMBNAIL = '100px';

const styleThumbnail = {
  width: WIDTH_THUMBNAIL,
  height: WIDTH_THUMBNAIL,
  marginRight: 8,
  borderRadius: '4px',
};

const calculateSize = (mWidth = MAX_WIDTH, mHeight = MAX_HEIGHT, mMaxWidth, mMaxHeight) => {
  const scaleWidth = mWidth / mMaxWidth;
  const scaleHeight = mHeight / mMaxHeight;
  let width = 0;
  let height = 0;
  if (mWidth < mMaxWidth && mHeight < mMaxHeight) {
    width = mWidth;
    height = mHeight;
  } else if (scaleWidth >= scaleHeight) {
    width = mMaxWidth;
    height = mHeight / scaleWidth;
  } else {
    width = mWidth / scaleHeight;
    height = mMaxHeight;
  }
  return {
    width,
    height,
    minWidth: width,
  };
};

class MessageMedia extends Component {
  onClickImage = file => {
    const { conversationId } = this.props;
    this.props.openGallery(conversationId, file);
  };

  render() {
    const {
      disableClick,
      message: {
        id,
        message: { media },
      },
    } = this.props;

    const isMultiImage = media?.length > 1;

    const styleLoading = {
      backgroundColor: '#e7e7e7',
    };

    return (
      <div id={`message_${id}`}>
        {media?.map(i => {
          const style = isMultiImage
            ? styleThumbnail
            : calculateSize(i?.meta?.width, i?.meta?.height, MAX_WIDTH, MAX_HEIGHT);
          return (
            <PrivateImage
              style={style}
              styleLoading={styleLoading}
              key={i.id}
              src={i.previewPath}
              onClick={() => !disableClick && this.onClickImage(i)}
            />
          );
        })}
      </div>
    );
  }
}

MessageMedia.propTypes = {
  message: shape({}).isRequired,
  openGallery: func.isRequired,
  conversationId: number.isRequired,
  disableClick: bool,
};

MessageMedia.defaultProps = {
  disableClick: false,
};

const mapStateToProps = state => ({
  token: state.auth.data.token,
});

const mapDispatchToProps = {
  openGallery,
};

export default connect(mapStateToProps, mapDispatchToProps)(MessageMedia);
